import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { colors, GoodSansHeader1, H1, H2, P, QueensH1 } from '@components/shared'

export const BGImageContainer = styled.div<any>`
  margin-top: -60px;
  ${(props: any): any => config(props).media.md`
    margin-top: -75px;
  `}

  min-height: 100vh;
  position: relative;
  z-index: 0;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility:    hidden;
  -ms-backface-visibility:     hidden;
  transform: translate3d(0,0,0);
  width: 100%;
`
export const QuizBGContainer = styled.div<any>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -1;
  display: flex;
  overflow: hidden;
`
export const QuizTopContainer = styled.div<any>`
  display: flex;
  min-height: 100vh;
  position: relative;
  padding: 100px 0 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  box-sizing: border-box;
`
export const GradientContainer = styled.div<any>`
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding: 0 0 10vh;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 54.19%, #26122F 71.56%);
  ${(props: any): any => config(props).media.md`
    align-items: center;
    padding: 0 0 40px;
    background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 41.11%, #26122F 54.26%);
  `}
  ${(props: any): any => config(props).media.lg`
    background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 47.56%, #26122F 71.56%);
  `}
  ${(props: any): any => config(props).media.xl`
    background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 58.59%, #26122F 81.64%);
  `}
`
export const QuizHeaderText = styled.h1<any>`
  ${QueensH1};
  font-family: "Queens Condensed Light";
  line-height: 120%;
  margin-bottom: 1.25rem;
  
  font-size: 50px;
  text-align: center;
  ${(props: any): any => config(props).media.md`
    font-size: 60px;
  `}
  ${(props: any): any => config(props).media.lg`
    font-size: 70px;
    text-align: left;
  `}
`
export const QuizResultsHeaderText = styled(H1)<any>`
  margin-bottom: 30px;
  padding: 0px;
  text-align: center;
  ${(props: any): any => config(props).media.md`
    padding: 0 30px;
  `}
`
export const QuizBodyText = styled(P)<any>`
  font-size: 16px;
  margin: 0 0 20px;
  text-align: center;
  ${(props: any): any => config(props).media.lg`
    font-size: 18px;
    text-align: left;
    margin: 0 0 30px;
  `}
`
export const QuizButton = styled.button<any>`
  font-family: "Good Sans Bold";
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  background: ${colors.orange};
  border-radius: 100px;
  padding: 12px 40px;
  outline: none;
  border: none;
  color: ${colors.white};
  will-change: opacity;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
  ${(props: any): any => config(props).media.md`
    max-width: 230px;
    cursor: pointer;
    &:hover,
    &:focus {
      opacity: 0.5;
    }
  `}
`
export const ProgressBar = styled.div<any>`
  height: 6px;
  position: relative;
  background: ${colors.white25};
  backdrop-filter: blur(20px);
  transition: opacity .6s cubic-bezier(0.19, 1, 0.22, 1);
  opacity: ${(props: any): any => props.showProgressBar ? '1' : '0'};
  ${(props: any): any => config(props).media.md`
    height: 8px;
  `}

  margin-top: 60px;
  ${(props: any): any => config(props).media.md`
    margin-top: 75px;
  `}
  &:after {
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    background-color: ${colors.orange};
    width: ${(props: any): any => props.progress}%;
    z-index: 1;
    position: absolute;
    transition: width .6s cubic-bezier(0.19, 1, 0.22, 1);
    will-change: width;
    border-radius: 0 10px 10px 0;
  }
`
export const QuizBlock = styled.div<any>`
  display: flex;
  min-height: ${(props: any): any => props.isSignedIn ? 'calc(100vh - 55px);' : '100vh;'}
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  padding: 82px 20px;
  margin: 0 auto;
  flex-direction: column;
  * {
    box-sizing: border-box;
  }
  div {
    width: 100%;
  }
  ${(props: any): any => config(props).media.md`
    min-height: 100vh;
    max-width: 500px;
  `}
  ${(props: any): any => config(props).media.lg`
    max-width: 656px;
  `}
`
export const ImgWrapper = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
  opacity: 1;
  transition: opacity .6s cubic-bezier(0.19, 1, 0.22, 1);
  will-change: opacity;
  transform: translateZ(0);
  ${(props: any): any => props.transitioning && (`
    opacity: 0;
  `)}
  ${(props: any): any => config(props).media.md`
    margin-top: 32px;
  `}
`
export const QuizImg = styled.img<any>`
  width: 32px;
  height: 32px;
  ${(props: any): any => config(props).media.md`
    width: 56px;
    height: 56px;
    justify-content: center;
  `}
`
export const QuizTextWrapper = styled.div<any>`
  margin-top: 16px;
  opacity: 1;
  transition: opacity .6s cubic-bezier(0.19, 1, 0.22, 1);
  will-change: opacity;
  width: 100%;
  transform: translateZ(0);
  text-align: center;
  ${(props: any): any => props.transitioning && (`
    opacity: 0;
  `)}
  ${(props: any): any => config(props).media.md`
    margin-top: 32px;
  `}
`
export const QuestionText = styled(H2)<any>`
  margin-bottom: 16px;
  text-align: center;
  font-size: 45px;
  line-height: 120%;
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 24px;
    font-size: 60px;
  `}
`
export const QuestionText2 = styled(QuestionText)<any>`
  font-size: 36px;
  ${(props: any): any => config(props).media.lg`
    font-size: 60px;
  `}
`
export const QuizResultSubText = styled.h2<any>`
  color: ${colors.white};
  font-family: "Good Sans Bold";
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 150%;
  margin-block: 0;
  margin: 0;
  padding: 0;
`
export const QuizResultsText = styled(P)<any>`
  margin-bottom: 16px;
  font-size: 16px;
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 24px;
    font-size: 18px;
  `}
`
export const QuizSubtext = styled(P)<any>`
  margin-bottom: 32px;
  text-align: center;
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 60px;
  `}
`
export const AnswersWrapper = styled.div<any>`
  margin-top: 32px;
  margin-bottom: 54px;
  width: 100%;
  opacity: 1;
  transition: opacity .6s cubic-bezier(0.19, 1, 0.22, 1);
  will-change: opacity;
  transform: translateZ(0);
  ${(props: any): any => props.transitioning && (`
    opacity: 0;
    transition: opacity .6s cubic-bezier(0.19, 1, 0.22, 1) .2s;
  `)}

  input[type="radio"] {
    height: 0;
    width: 0;
    position: absolute;
    opacity: 0;
  }
  input[type="radio"] + label {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #F6F3F0;
    box-sizing: border-box;
    border-radius: 100px;
    flex: 1;
    transition: background-color .2s cubic-bezier(0.19, 1, 0.22, 1), color .2s cubic-bezier(0.19, 1, 0.22, 1);
    p {
      margin: 0;
    }
  }
  input[type="radio"]:checked + label,
  input[type="radio"]:focus + label {
    background-color: ${colors.orange};
    color: ${colors.white};
    border: 1px solid ${colors.orange};
  }
  ${(props: any): any => config(props).media.md`
    margin-top: 56px;
    margin-bottom: 0;
  `}
  ${(props: any): any => config(props).media.lg`
    input[type="radio"] + label {
      transition: background-color .6s cubic-bezier(0.19, 1, 0.22, 1), color .6s cubic-bezier(0.19, 1, 0.22, 1);
    }
    input[type="radio"]:hover:not(:checked) + label {
      background-color: ${colors.orange};
      color: ${colors.white};
    }
  `}
`
export const SingleAnswerWrapper = styled.div<any>`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  ${(props: any): any => config(props).media.md`
    margin-bottom: 32px;
  `}
`
export const AnswerText = styled(GoodSansHeader1)<any>`
  padding: 12px 20px;
  text-align: center;
  line-height: 125%;
  ${(props: any): any => config(props).media.lg`
    padding: 17px 40px;
  `}
`
export const AuthFormWrapper = styled.div<any>`
  border: 1px solid ${colors.white};
  box-sizing: border-box;
  border-radius: 10px;
  padding: 22px;
  max-width: 466px;
  margin: 0 auto;
  ${(props: any): any => config(props).media.md`
    padding: 36px;
  `}
  ${(props: any): any => config(props).media.lg`
    max-width: 527px;
  `}
  button.tc-authform-submit {
    background-color: ${colors.orange};
  }
`
export const TopBanner = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 32px;
  padding: 0px 15px;
  background: ${(props: { bannerBackground?: string }): string => props.bannerBackground || 'unset'};
  background-color: ${colors.orange};
  z-index: 1002;
  ${(props: any): any => config(props).media.md`
    height: 56px;
  `}
`
export const BannerText = styled.p<any>`
  font-family: 'Good Sans Bold';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  margin-left: ${(props: {marginLeft?: number}): number => props.marginLeft || 0}px;
  color: ${colors.white};
  ${(props: any): any => config(props).media.md`
    text-align: center;
    font-size: 16px;
  `}
`
